import styled from "@emotion/styled";

import { LiveArticleTimelineItem } from "./item";

export const Container = styled.div``;

export const StyledLiveArticleTimelineItem = styled(LiveArticleTimelineItem)``;
